/**
 * Bakery gallery carousel
 */

import Glide from '@glidejs/glide';
import ImagesLoaded from 'imagesloaded';

export default {

	/** @type {Glide} glide instance */
	inst: null,

	/** @type {Object} glide options */
	glideOpts: {
		type: 'carousel',
		perView: 1,
	},

	/**
	 * Initialize
	 */
	init() {

		if(!document.querySelector('#bakery-carousel')) return;

		this.inst = new Glide('#bakery-carousel', this.glideOpts);

		this.inst.on(['mount.after', 'run', 'resize'], () => this.resize());
		this.inst.on('mount.before', () => this.bindThumbs());
		this.inst.on('mount.before', () => this.imagesLoaded());
		this.inst.on(['mount.after', 'run'], () => this.setActiveThumb());

		this.inst.mount();
	},

	/**
	 * Resize the container on slide change
	 */
	resize() {
		const { Html } = this.inst._c;
		const { track } = Html;
		const slide = Html.slides[this.inst.index];

		track.style.height = `${slide.offsetHeight}px`;
	},

	/**
	 * Bind thumbnail click actions
	 */
	bindThumbs() {
		const thumbs = document.querySelectorAll('.bakery-carousel-nav-item');

		for(let i = 0; i < thumbs.length; i++) {
    		thumbs[i].addEventListener('click', e => {
    			this.inst.go('=' + i);
    		});
        }
	},

	/**
	 * Set the active thumbnail
	 */
	setActiveThumb() {
		const { Html } = this.inst._c;
		const { track } = Html;
		const slide = Html.slides[this.inst.index];
		const active = document.querySelector('.bakery-carousel-nav-item.is-active');
		const navItems = document.querySelectorAll('.bakery-carousel-nav-item');

		if(active) active.classList.remove('is-active');

		navItems[this.inst.index].classList.add('is-active');
	},

	/**
	 * Images loaded bindings
	 */
	imagesLoaded() {
		new ImagesLoaded(document.getElementById('bakery-carousel'), instance => {
			this.resize();
		});
	}

}